import React, { Component } from 'react'
import Logo from "../imgs/logo.jpg";

class Form2Header extends Component {
    render() {
        return (
            <div>
                <div className="header_sec">
                    <div className="header_logo_left">
                        <a href="/">
                        <img src={Logo} alt="Referral for Direct Schedule Screening Colonoscopy with Dr. Yamini Maddala" />
                        </a>
                    </div>
                    <div className="header_right">
                        <p>Yamini Maddala, M.D.,</p>
                        <p>Deepti Dhavaleshwar, M.D.,</p>
                        <p>
                        Phone: <span className="pno">469.697.5100</span>
                        </p>
                    </div>
                </div>
                <div className="address_section">
                    <div className="address_left">
                        <p>280 Adriatic Pkwy</p>
                        <p>McKinney, TX-75070</p>
                        <p>(469) 697-5100</p>
                        <p>(469) 697-5105 Fax</p>
                    </div>
                    <div className="address_center">
                        <p>981 State Highway 121</p>
                        <p>Suite: 1140 Allen, TX-75013</p>
                        <p>(469) 697-5100</p>
                        <p>(469) 697-5105 Fax</p>
                    </div>
                    <div className="address_right">
                        <p>170 N. Preston Rd</p>
                        <p>Suite: 40 Prosper, TX-75069</p>
                        <p>(469) 697-5100</p>
                        <p>(469) 697-5105 Fax</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Form2Header